import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Layout = ({ children }) => {
    return (_jsx("div", { className: "min-h-screen", children: _jsx("div", { className: "py-6", children: _jsx("main", { children: _jsx("div", { children: children }) }) }) }));
};
export const SectionTitle = ({ title, subtitle, action }) => {
    return (_jsxs("div", { className: "flex flex-col md:flex-row md:items-center justify-between mb-6", children: [_jsxs("div", { children: [_jsx("h2", { className: "text-2xl font-bold text-gray-900", children: title }), subtitle && _jsx("p", { className: "mt-1 text-sm text-gray-500", children: subtitle })] }), action && _jsx("div", { className: "mt-3 md:mt-0", children: action })] }));
};
export const Card = ({ children, className = '' }) => {
    return (_jsx("div", { className: `bg-white shadow-md rounded-lg overflow-hidden ${className}`, children: children }));
};
export const CardHeader = ({ title, subtitle, action }) => {
    return (_jsxs("div", { className: "px-6 py-4 border-b border-gray-200 flex flex-col md:flex-row md:items-center justify-between", children: [_jsxs("div", { children: [_jsx("h3", { className: "text-lg font-medium text-gray-900", children: title }), subtitle && _jsx("p", { className: "mt-1 text-sm text-gray-500", children: subtitle })] }), action && _jsx("div", { className: "mt-3 md:mt-0", children: action })] }));
};
export const CardBody = ({ children, className = '' }) => {
    return _jsx("div", { className: `px-6 py-4 ${className}`, children: children });
};
export const CardFooter = ({ children, className = '' }) => {
    return (_jsx("div", { className: `px-6 py-4 bg-gray-50 border-t border-gray-200 ${className}`, children: children }));
};
export const MetricCard = ({ title, value, icon, change, className = '' }) => {
    return (_jsx(Card, { className: className, children: _jsx(CardBody, { children: _jsxs("div", { className: "flex items-center", children: [icon && _jsx("div", { className: "mr-4", children: icon }), _jsxs("div", { children: [_jsx("p", { className: "text-sm font-medium text-gray-500", children: title }), _jsx("p", { className: "text-2xl font-semibold text-gray-900", children: value }), change && (_jsx("div", { className: `flex items-center text-sm ${change.isPositive ? 'text-green-600' : 'text-red-600'}`, children: _jsxs("span", { children: [change.isPositive ? '↑' : '↓', " ", change.value] }) }))] })] }) }) }));
};
export const StatusBadge = ({ status, text }) => {
    const getStatusClass = () => {
        switch (status) {
            case 'success':
                return 'bg-green-100 text-green-800';
            case 'warning':
                return 'bg-yellow-100 text-yellow-800';
            case 'error':
                return 'bg-red-100 text-red-800';
            case 'info':
                return 'bg-blue-100 text-blue-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };
    return (_jsxs("span", { className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusClass()}`, children: [_jsx("span", { className: `w-2 h-2 mr-1.5 rounded-full ${status === 'success' ? 'bg-green-500' : status === 'warning' ? 'bg-yellow-500' : status === 'error' ? 'bg-red-500' : 'bg-blue-500'}` }), text] }));
};
// ボタン用コンポーネントは components/Button.tsx へ統一した。
// 既存の `import { Button } from '.../components/Layout'` を壊さないよう再エクスポートする。
export { default as Button } from './Button';
export default Layout;
